import { Link, useLocation } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面不存在 - CC视频",
    description: "你访问的页面不存在或已被移除，返回CC视频首页继续浏览影视内容与资讯。",
  });

  return (
    <div className="max-w-content mx-auto px-4 md:px-6 py-20 md:py-28 flex flex-col items-center text-center">
      <p className="font-heading font-bold text-7xl md:text-9xl text-primary-100 select-none">
        404
      </p>
      <h1 className="mt-4 text-2xl md:text-3xl font-heading font-bold text-foreground-950">
        页面不存在
      </h1>
      <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-md">
        你访问的地址暂时不可用，可能是链接有误或内容已被移除。
      </p>
      <p className="mt-1 text-xs text-foreground-400 font-mono break-all">
        {location.pathname}
      </p>
      <div className="mt-7 flex flex-col sm:flex-row gap-3">
        <Link
          to="/"
          className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium flex items-center justify-center gap-1.5 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="h-11 px-6 rounded-md border border-background-300 text-foreground-800 text-sm font-medium flex items-center justify-center gap-1.5 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-film-line"></i>
          浏览电影频道
        </Link>
      </div>
    </div>
  );
}